import React, {useState} from 'react';
import { View } from 'react-native';

const SubNav = ({children}) => {
  return (
    <View>
      {children}
    </View>
  )
}

export default SubNav;
